window.CP_POS_PROFILES = window.CP_POS_PROFILES || {};

// 1) DEFAULT fallback profile (use your current working maps here)
window.CP_POS_PROFILES.default = {
  standard: {
    small:   { 1:{x:50.020,y:90.097}, 2:{x:33.815,y:83.285}, 3:{x:65.412,y:83.285}, 4:{x:23.555,y:69.273}, 5:{x:75.477,y:69.273}, 6:{x:16.502,y:53.331}, 7:{x:82.689,y:53.331}, 8:{x:11.289,y:36.614}, 9:{x:88.304,y:36.614} },
    medium:  { 1:{x:50.020,y:90.897}, 2:{x:33.815,y:84.285}, 3:{x:65.412,y:84.285}, 4:{x:23.555,y:70.273}, 5:{x:75.477,y:70.273}, 6:{x:16.502,y:54.331}, 7:{x:82.689,y:54.331}, 8:{x:10.989,y:37.614}, 9:{x:88.204,y:37.614} },
    large:   { 1:{x:50.020,y:91.897}, 2:{x:33.815,y:85.285}, 3:{x:65.412,y:85.285}, 4:{x:23.555,y:71.273}, 5:{x:75.477,y:71.273}, 6:{x:16.502,y:55.331}, 7:{x:82.689,y:55.331}, 8:{x:10.689,y:38.614}, 9:{x:88.104,y:38.614} },
    morelarge:{ 1:{x:50.020,y:92.897}, 2:{x:33.815,y:86.285}, 3:{x:65.412,y:86.285}, 4:{x:23.555,y:72.273}, 5:{x:75.477,y:72.273}, 6:{x:16.502,y:56.331}, 7:{x:82.689,y:56.331}, 8:{x:10.389,y:39.614}, 9:{x:88.104,y:39.614} }
  },
  tight: {
    small:   { 1:{x:50.020,y:90.097}, 2:{x:38.900,y:86.750}, 3:{x:60.900,y:86.750}, 4:{x:29.950,y:79.000}, 5:{x:69.350,y:79.000}, 6:{x:23.523,y:69.550}, 7:{x:75.850,y:69.550}, 8:{x:18.500,y:58.850}, 9:{x:80.700,y:58.850} },
    medium:  { 1:{x:50.020,y:90.897}, 2:{x:38.900,y:87.750}, 3:{x:60.900,y:87.750}, 4:{x:29.950,y:80.000}, 5:{x:69.350,y:80.000}, 6:{x:23.523,y:70.550}, 7:{x:75.850,y:70.550}, 8:{x:18.500,y:59.850}, 9:{x:80.700,y:59.850} },
    large:   { 1:{x:50.020,y:91.897}, 2:{x:38.500,y:88.750}, 3:{x:60.200,y:88.750}, 4:{x:29.950,y:81.000}, 5:{x:69.350,y:81.000}, 6:{x:23.523,y:71.550}, 7:{x:75.850,y:71.550}, 8:{x:18.500,y:60.850}, 9:{x:80.700,y:60.850} },
    morelarge:{ 1:{x:50.020,y:92.897}, 2:{x:38.900,y:89.750}, 3:{x:60.900,y:89.750}, 4:{x:29.950,y:82.000}, 5:{x:69.350,y:82.000}, 6:{x:23.523,y:72.550}, 7:{x:75.850,y:72.550}, 8:{x:18.500,y:61.850}, 9:{x:80.700,y:61.850} }
  }
};

// 2) OPTIONAL: product-specific profiles go here later (Step 5)

window.CP_POS_PROFILES["color-pop-freshwater-pearl-necklace"] = {
  standard: {
    small: {
      1:{x:50.020,y:90.097},2:{x:33.815,y:83.285},3:{x:65.412,y:83.285},4:{x:23.555,y:69.273},5:{x:75.477,y:69.273},6:{x:16.502,y:53.331},7:{x:82.689,y:53.331},8:{x:11.289,y:36.614},9:{x:88.304,y:36.614}
    },
    medium: {
      1:{x:50.020,y:90.897},2:{x:33.815,y:84.285},3:{x:65.412,y:84.285},4:{x:23.555,y:70.273},5:{x:75.477,y:70.273},6:{x:16.502,y:54.331},7:{x:82.689,y:54.331},8:{x:10.989,y:37.614},9:{x:88.204,y:37.614}
    },
    large: {
      1:{x:53.320,y:84.897},2:{x:33.815,y:85.285},3:{x:65.412,y:85.285},4:{x:23.555,y:71.273},5:{x:75.477,y:71.273},6:{x:16.502,y:55.331},7:{x:82.689,y:55.331},8:{x:10.689,y:38.614},9:{x:88.104,y:38.614}
    },
    morelarge: {
      1:{x:50.020,y:92.897},2:{x:33.815,y:86.285},3:{x:65.412,y:86.285},4:{x:23.555,y:72.273},5:{x:75.477,y:72.273},6:{x:16.502,y:56.331},7:{x:82.689,y:56.331},8:{x:10.389,y:39.614},9:{x:88.104,y:39.614}
    }
  },
  tight: {
    small: {
      1:{x:50.020,y:90.097},2:{x:33.815,y:83.285},3:{x:65.412,y:83.285},4:{x:23.555,y:69.273},5:{x:75.477,y:69.273},6:{x:16.502,y:53.331},7:{x:82.689,y:53.331},8:{x:11.289,y:36.614},9:{x:88.304,y:36.614}
    },
    medium: {
      1:{x:50.020,y:90.897},2:{x:33.815,y:84.285},3:{x:65.412,y:84.285},4:{x:23.555,y:70.273},5:{x:75.477,y:70.273},6:{x:16.502,y:54.331},7:{x:82.689,y:54.331},8:{x:10.989,y:37.614},9:{x:88.204,y:37.614}
    },
    large: {
      1:{x:53.320,y:84.897},2:{x:33.815,y:85.285},3:{x:65.412,y:85.285},4:{x:23.555,y:71.273},5:{x:75.477,y:71.273},6:{x:16.502,y:55.331},7:{x:82.689,y:55.331},8:{x:10.689,y:38.614},9:{x:88.104,y:38.614}
    },
    morelarge: {
      1:{x:50.020,y:92.897},2:{x:33.815,y:86.285},3:{x:65.412,y:86.285},4:{x:23.555,y:72.273},5:{x:75.477,y:72.273},6:{x:16.502,y:56.331},7:{x:82.689,y:56.331},8:{x:10.389,y:39.614},9:{x:88.104,y:39.614}
    }
  }
};

window.CP_POS_PROFILES["create-your-own-charm-bracelet-gold-plated-small-paperclip-chain"] = {
  standard: {
    xsmall: {
      1:{x:50.620,y:79.097,r:-0},2:{x:34.915,y:74.985,r:25},3:{x:66.585,y:74.385,r:-25},4:{x:23.555,y:62.273,r:55},5:{x:77.355,y:61.473,r:-57.5},6:{x:21.502,y:44.831,r:102.5},7:{x:78.689,y:44.231,r:-102.5},8:{x:29.389,y:30.114,r:140},9:{x:70.011,y:29.514,r:-140}
    },
    small: {
      1:{x:50.620,y:79.097,r:-0},2:{x:34.915,y:74.985,r:25},3:{x:66.585,y:74.385,r:-25},4:{x:23.555,y:62.273,r:55},5:{x:77.355,y:61.473,r:-57.5},6:{x:21.502,y:44.831,r:102.5},7:{x:78.689,y:44.231,r:-102.5},8:{x:29.389,y:30.114,r:140},9:{x:70.011,y:29.514,r:-140}
    },
    medium: {
      1:{x:50.620,y:79.597,r:-0},2:{x:34.415,y:75.485,r:25},3:{x:67.085,y:75.285,r:-25},4:{x:22.855,y:62.773,r:55},5:{x:78.355,y:61.473,r:-57.5},6:{x:20.502,y:44.831,r:102.5},7:{x:79.689,y:44.231,r:-102.5},8:{x:29.089,y:29.314,r:140},9:{x:70.011,y:29.014,r:-140}
    },
    large: {
      1:{x:50.620,y:80.797,r:-0},2:{x:34.115,y:76.285,r:25},3:{x:67.085,y:75.685,r:-25},4:{x:22.355,y:63.473,r:55},5:{x:78.755,y:62.273,r:-57.5},6:{x:19.702,y:44.531,r:102.5},7:{x:80.489,y:44.031,r:-102.5},8:{x:27.989,y:28.814,r:140},9:{x:70.971,y:28.114,r:-140}
    },
    morelarge: {
      1:{x:50.620,y:82.097,r:-0},2:{x:33.815,y:77.085,r:25},3:{x:67.385,y:76.885,r:-25},4:{x:21.855,y:64.073,r:55},5:{x:79.155,y:62.973,r:-57.5},6:{x:18.852,y:44.331,r:102.5},7:{x:81.289,y:43.831,r:-102.5},8:{x:27.075,y:28.114,r:140},9:{x:71.871,y:27.214,r:-140}
    }
  },
  tight: {
    small: {
      1:{x:50.620,y:79.097,r:-0},2:{x:34.915,y:74.985,r:25},3:{x:66.585,y:74.385,r:-25},4:{x:23.555,y:62.273,r:55},5:{x:77.355,y:61.473,r:-57.5},6:{x:21.502,y:44.831,r:102.5},7:{x:78.689,y:44.231,r:-102.5},8:{x:29.389,y:30.114,r:140},9:{x:70.011,y:29.514,r:-140}
    },
    medium: {
      1:{x:50.620,y:79.597,r:-0},2:{x:34.415,y:75.485,r:25},3:{x:67.085,y:75.285,r:-25},4:{x:22.855,y:62.773,r:55},5:{x:78.355,y:61.473,r:-57.5},6:{x:20.502,y:44.831,r:102.5},7:{x:79.689,y:44.231,r:-102.5},8:{x:29.089,y:29.314,r:140},9:{x:70.011,y:29.014,r:-140}
    },
    large: {
      1:{x:50.620,y:80.797,r:-0},2:{x:34.115,y:76.285,r:25},3:{x:67.085,y:75.685,r:-25},4:{x:22.355,y:63.473,r:55},5:{x:78.755,y:62.273,r:-57.5},6:{x:19.702,y:44.531,r:102.5},7:{x:80.489,y:44.031,r:-102.5},8:{x:27.989,y:28.814,r:140},9:{x:70.971,y:28.114,r:-140}
    },
    morelarge: {
      1:{x:50.620,y:82.097,r:-0},2:{x:33.815,y:77.085,r:25},3:{x:67.385,y:76.885,r:-25},4:{x:21.855,y:64.073,r:55},5:{x:79.155,y:62.973,r:-57.5},6:{x:18.852,y:44.331,r:102.5},7:{x:81.289,y:43.831,r:-102.5},8:{x:27.075,y:28.114,r:140},9:{x:71.871,y:27.214,r:-140}
    }
  }
};

window.CP_POS_PROFILES["create-your-own-charm-bracelet-gold-plated-paperclip-chain"] = {
  standard: {
    small: {
      1:{x:50.620,y:79.097,r:-0},2:{x:34.915,y:74.985,r:25},3:{x:66.585,y:74.385,r:-25},4:{x:23.555,y:62.273,r:55},5:{x:77.355,y:61.473,r:-57.5},6:{x:21.502,y:44.831,r:102.5},7:{x:78.689,y:44.231,r:-102.5},8:{x:29.389,y:30.114,r:140},9:{x:70.011,y:29.514,r:-140}
    },
    medium: {
      1:{x:50.620,y:79.597,r:-0},2:{x:34.415,y:75.485,r:25},3:{x:67.085,y:75.285,r:-25},4:{x:22.855,y:62.773,r:55},5:{x:78.355,y:61.473,r:-57.5},6:{x:20.502,y:44.831,r:102.5},7:{x:79.689,y:44.231,r:-102.5},8:{x:29.089,y:29.314,r:140},9:{x:70.011,y:29.014,r:-140}
    },
    large: {
      1:{x:50.620,y:80.797,r:-0},2:{x:34.115,y:76.285,r:25},3:{x:67.085,y:75.685,r:-25},4:{x:22.355,y:63.473,r:55},5:{x:78.755,y:62.273,r:-57.5},6:{x:19.702,y:44.531,r:102.5},7:{x:80.489,y:44.031,r:-102.5},8:{x:27.989,y:28.814,r:140},9:{x:70.971,y:28.114,r:-140}
    },
    morelarge: {
      1:{x:50.620,y:82.097,r:-0},2:{x:33.815,y:77.085,r:25},3:{x:67.385,y:76.885,r:-25},4:{x:21.855,y:64.073,r:55},5:{x:79.155,y:62.973,r:-57.5},6:{x:18.852,y:44.331,r:102.5},7:{x:81.289,y:43.831,r:-102.5},8:{x:27.075,y:28.114,r:140},9:{x:71.871,y:27.214,r:-140}
    }
  },
  tight: {
    small: {
      1:{x:50.620,y:79.097,r:-0},2:{x:34.915,y:74.985,r:25},3:{x:66.585,y:74.385,r:-25},4:{x:23.555,y:62.273,r:55},5:{x:77.355,y:61.473,r:-57.5},6:{x:21.502,y:44.831,r:102.5},7:{x:78.689,y:44.231,r:-102.5},8:{x:29.389,y:30.114,r:140},9:{x:70.011,y:29.514,r:-140}
    },
    medium: {
      1:{x:50.620,y:79.597,r:-0},2:{x:34.415,y:75.485,r:25},3:{x:67.085,y:75.285,r:-25},4:{x:22.855,y:62.773,r:55},5:{x:78.355,y:61.473,r:-57.5},6:{x:20.502,y:44.831,r:102.5},7:{x:79.689,y:44.231,r:-102.5},8:{x:29.089,y:29.314,r:140},9:{x:70.011,y:29.014,r:-140}
    },
    large: {
      1:{x:50.620,y:80.797,r:-0},2:{x:34.115,y:76.285,r:25},3:{x:67.085,y:75.685,r:-25},4:{x:22.355,y:63.473,r:55},5:{x:78.755,y:62.273,r:-57.5},6:{x:19.702,y:44.531,r:102.5},7:{x:80.489,y:44.031,r:-102.5},8:{x:27.989,y:28.814,r:140},9:{x:70.971,y:28.114,r:-140}
    },
    morelarge: {
      1:{x:50.620,y:82.097,r:-0},2:{x:33.815,y:77.085,r:25},3:{x:67.385,y:76.885,r:-25},4:{x:21.855,y:64.073,r:55},5:{x:79.155,y:62.973,r:-57.5},6:{x:18.852,y:44.331,r:102.5},7:{x:81.289,y:43.831,r:-102.5},8:{x:27.075,y:28.114,r:140},9:{x:71.871,y:27.214,r:-140}
    }
  }
};

window.CP_POS_PROFILES["build-your-own-charm-necklace-14k-gold-plated-small-paperclip-chain"] = {
  standard: {
    small: {
      1:{x:50.620,y:84.097,r:-0},2:{x:34.915,y:77.085,r:0},3:{x:66.585,y:76.685,r:-0},4:{x:25.555,y:61.473,r:0},5:{x:75.355,y:61.473,r:-0},6:{x:19.502,y:43.431,r:0},7:{x:81.689,y:43.231,r:0},8:{x:14.589,y:25.814,r:0},9:{x:86.211,y:26.014,r:-0}
    },
    medium: {
      1:{x:50.620,y:85.297,r:-0},2:{x:34.915,y:77.085,r:0},3:{x:66.585,y:76.685,r:-0},4:{x:25.555,y:62.273,r:0},5:{x:75.355,y:62.473,r:-0},6:{x:19.102,y:44.231,r:0},7:{x:81.689,y:44.231,r:0},8:{x:14.589,y:26.814,r:0},9:{x:86.211,y:27.014,r:-0}
    },
    large: {
      1:{x:50.620,y:86.297,r:-0},2:{x:34.515,y:78.085,r:0},3:{x:66.085,y:77.985,r:-0},4:{x:25.255,y:62.273,r:0},5:{x:75.355,y:62.473,r:-0},6:{x:18.902,y:45.631,r:0},7:{x:81.389,y:45.631,r:0},8:{x:14.989,y:27.514,r:0},9:{x:85.711,y:27.514,r:-0}
    },
    morelarge: {
      1:{x:50.620,y:88.097,r:-0},2:{x:34.515,y:79.885,r:0},3:{x:66.085,y:79.785,r:-0},4:{x:25.255,y:64.073,r:0},5:{x:75.355,y:64.273,r:-0},6:{x:18.902,y:47.431,r:0},7:{x:81.389,y:47.431,r:0},8:{x:14.989,y:29.714,r:0},9:{x:85.711,y:29.714,r:-0}
    }
  },
  tight: {
    small: {
      1:{x:50.620,y:84.097,r:-0},2:{x:34.915,y:77.085,r:0},3:{x:66.585,y:76.685,r:-0},4:{x:25.555,y:61.473,r:0},5:{x:75.355,y:61.473,r:-0},6:{x:19.502,y:43.431,r:0},7:{x:81.689,y:43.231,r:0},8:{x:14.589,y:25.814,r:0},9:{x:86.211,y:26.014,r:-0}
    },
    medium: {
      1:{x:50.620,y:85.297,r:-0},2:{x:34.915,y:77.085,r:0},3:{x:66.585,y:76.685,r:-0},4:{x:25.555,y:62.273,r:0},5:{x:75.355,y:62.473,r:-0},6:{x:19.102,y:44.231,r:0},7:{x:81.689,y:44.231,r:0},8:{x:14.589,y:26.814,r:0},9:{x:86.211,y:27.014,r:-0}
    },
    large: {
      1:{x:50.620,y:86.297,r:-0},2:{x:34.515,y:78.085,r:0},3:{x:66.085,y:77.985,r:-0},4:{x:25.255,y:62.273,r:0},5:{x:75.355,y:62.473,r:-0},6:{x:18.902,y:45.631,r:0},7:{x:81.389,y:45.631,r:0},8:{x:14.989,y:27.514,r:0},9:{x:85.711,y:27.514,r:-0}
    },
    morelarge: {
      1:{x:50.620,y:88.097,r:-0},2:{x:34.515,y:79.885,r:0},3:{x:66.085,y:79.785,r:-0},4:{x:25.255,y:64.073,r:0},5:{x:75.355,y:64.273,r:-0},6:{x:18.902,y:47.431,r:0},7:{x:81.389,y:47.431,r:0},8:{x:14.989,y:29.714,r:0},9:{x:85.711,y:29.714,r:-0}
    }
  }
};

window.CP_POS_PROFILES["create-your-own-charm-necklace-14k-gold-plated-tiny-paperclip-chain"] = {
  standard: {
    small: {
      1:{x:49.990,y:83.097,r:-0},2:{x:35.715,y:74.485,r:0},3:{x:64.085,y:74.085,r:-0},4:{x:28.055,y:61.473,r:0},5:{x:72.055,y:61.473,r:-0},6:{x:24.452,y:48.031,r:0},7:{x:76.789,y:48.031,r:0},8:{x:20.589,y:29.214,r:0},9:{x:79.511,y:29.214,r:-0}
    },
    medium: {
      1:{x:49.990,y:84.097,r:-0},2:{x:35.715,y:75.485,r:0},3:{x:64.085,y:75.085,r:-0},4:{x:28.055,y:62.473,r:0},5:{x:72.055,y:62.473,r:-0},6:{x:24.452,y:49.031,r:0},7:{x:76.789,y:49.031,r:0},8:{x:20.589,y:30.214,r:0},9:{x:79.511,y:30.214,r:-0}
    },
    large: {
      1:{x:49.990,y:85.097,r:-0},2:{x:35.715,y:76.485,r:0},3:{x:64.085,y:76.085,r:-0},4:{x:28.055,y:63.073,r:0},5:{x:72.055,y:63.073,r:-0},6:{x:24.452,y:49.031,r:0},7:{x:76.789,y:49.031,r:0},8:{x:20.589,y:31.214,r:0},9:{x:79.511,y:31.214,r:-0}
    },
    morelarge: {
      1:{x:49.990,y:87.097,r:-0},2:{x:35.715,y:78.485,r:0},3:{x:64.085,y:78.085,r:-0},4:{x:28.055,y:65.073,r:0},5:{x:72.055,y:65.073,r:-0},6:{x:24.452,y:51.031,r:0},7:{x:76.789,y:51.031,r:0},8:{x:20.589,y:33.214,r:0},9:{x:79.511,y:33.214,r:-0}
    }
  },
  tight: {
    small: {
      1:{x:49.990,y:83.097,r:-0},2:{x:35.715,y:74.485,r:0},3:{x:64.085,y:74.085,r:-0},4:{x:28.055,y:61.473,r:0},5:{x:72.055,y:61.473,r:-0},6:{x:24.452,y:48.031,r:0},7:{x:76.789,y:48.031,r:0},8:{x:20.589,y:29.214,r:0},9:{x:79.511,y:29.214,r:-0}
    },
    medium: {
      1:{x:49.990,y:84.097,r:-0},2:{x:35.715,y:75.485,r:0},3:{x:64.085,y:75.085,r:-0},4:{x:28.055,y:62.473,r:0},5:{x:72.055,y:62.473,r:-0},6:{x:24.452,y:49.031,r:0},7:{x:76.789,y:49.031,r:0},8:{x:20.589,y:30.214,r:0},9:{x:79.511,y:30.214,r:-0}
    },
    large: {
      1:{x:49.990,y:85.097,r:-0},2:{x:35.715,y:76.485,r:0},3:{x:64.085,y:76.085,r:-0},4:{x:28.055,y:63.073,r:0},5:{x:72.055,y:63.073,r:-0},6:{x:24.452,y:49.031,r:0},7:{x:76.789,y:49.031,r:0},8:{x:20.589,y:31.214,r:0},9:{x:79.511,y:31.214,r:-0}
    },
    morelarge: {
      1:{x:49.990,y:87.097,r:-0},2:{x:35.715,y:78.485,r:0},3:{x:64.085,y:78.085,r:-0},4:{x:28.055,y:65.073,r:0},5:{x:72.055,y:65.073,r:-0},6:{x:24.452,y:51.031,r:0},7:{x:76.789,y:51.031,r:0},8:{x:20.589,y:33.214,r:0},9:{x:79.511,y:33.214,r:-0}
    }
  }
};

window.CP_POS_PROFILES["create-your-own-charm-necklace-14k-gold-plated-standard-cable-chain"] = {
  standard: {
    small: {
      1:{x:50.500,y:86.500,r:-0},2:{x:33.000,y:74.500,r:0},3:{x:67.750,y:74.000,r:-0},4:{x:24.000,y:57.500,r:0},5:{x:76.500,y:57.500,r:-0},6:{x:18.250,y:39.500,r:0},7:{x:82.750,y:39.500,r:0},8:{x:13.500,y:21.250,r:0},9:{x:87.750,y:21.500,r:-0}
    },
    medium: {
      1:{x:50.500,y:87.500,r:-0},2:{x:33.000,y:75.500,r:0},3:{x:67.750,y:75.000,r:-0},4:{x:24.000,y:58.500,r:0},5:{x:76.500,y:58.500,r:-0},6:{x:18.250,y:40.500,r:0},7:{x:82.750,y:40.500,r:0},8:{x:13.500,y:22.250,r:0},9:{x:87.750,y:22.500,r:-0}
    },
    large: {
      1:{x:50.500,y:88.500,r:-0},2:{x:33.000,y:76.500,r:0},3:{x:67.750,y:76.000,r:-0},4:{x:24.000,y:59.500,r:0},5:{x:76.500,y:59.500,r:-0},6:{x:18.250,y:41.500,r:0},7:{x:82.750,y:41.500,r:0},8:{x:13.500,y:23.250,r:0},9:{x:87.750,y:23.500,r:-0}
    },
    morelarge: {
      1:{x:50.500,y:90.000,r:-0},2:{x:33.000,y:78.000,r:0},3:{x:67.750,y:77.500,r:-0},4:{x:24.000,y:61.000,r:0},5:{x:76.500,y:61.000,r:-0},6:{x:18.250,y:43.000,r:0},7:{x:82.750,y:43.000,r:0},8:{x:13.500,y:24.750,r:0},9:{x:87.750,y:25.000,r:-0}
    }
  },
  tight: {
    small: {
      1:{x:50.500,y:86.500,r:-0},2:{x:33.000,y:74.500,r:0},3:{x:67.750,y:74.000,r:-0},4:{x:24.000,y:57.500,r:0},5:{x:76.500,y:57.500,r:-0},6:{x:18.250,y:39.500,r:0},7:{x:82.750,y:39.500,r:0},8:{x:13.500,y:21.250,r:0},9:{x:87.750,y:21.500,r:-0}
    },
    medium: {
      1:{x:50.500,y:87.500,r:-0},2:{x:33.000,y:75.500,r:0},3:{x:67.750,y:75.000,r:-0},4:{x:24.000,y:58.500,r:0},5:{x:76.500,y:58.500,r:-0},6:{x:18.250,y:40.500,r:0},7:{x:82.750,y:40.500,r:0},8:{x:13.500,y:22.250,r:0},9:{x:87.750,y:22.500,r:-0}
    },
    large: {
      1:{x:50.500,y:88.500,r:-0},2:{x:33.000,y:76.500,r:0},3:{x:67.750,y:76.000,r:-0},4:{x:24.000,y:59.500,r:0},5:{x:76.500,y:59.500,r:-0},6:{x:18.250,y:41.500,r:0},7:{x:82.750,y:41.500,r:0},8:{x:13.500,y:23.250,r:0},9:{x:87.750,y:23.500,r:-0}
    },
    morelarge: {
      1:{x:50.500,y:90.000,r:-0},2:{x:33.000,y:78.000,r:0},3:{x:67.750,y:77.500,r:-0},4:{x:24.000,y:61.000,r:0},5:{x:76.500,y:61.000,r:-0},6:{x:18.250,y:43.000,r:0},7:{x:82.750,y:43.000,r:0},8:{x:13.500,y:24.750,r:0},9:{x:87.750,y:25.000,r:-0}
    }
  }
};

window.CP_POS_PROFILES["create-your-own-charm-necklace-14k-gold-plated-small-cable-chain"] = {
  standard: {
    small: {
      1:{x:50.500,y:86.000,r:-0},2:{x:35.250,y:75.000,r:0},3:{x:66.000,y:74.500,r:-0},4:{x:26.000,y:58.500,r:0},5:{x:74.500,y:58.000,r:-0},6:{x:20.250,y:40.250,r:0},7:{x:80.250,y:40.000,r:0},8:{x:15.500,y:21.250,r:0},9:{x:85.000,y:21.500,r:-0}
    },
    medium: {
      1:{x:50.500,y:87.000,r:-0},2:{x:35.250,y:76.000,r:0},3:{x:66.000,y:75.500,r:-0},4:{x:26.000,y:59.500,r:0},5:{x:74.500,y:59.000,r:-0},6:{x:20.250,y:41.250,r:0},7:{x:80.250,y:41.000,r:0},8:{x:15.500,y:22.250,r:0},9:{x:85.000,y:22.500,r:-0}
    },
    large: {
      1:{x:50.500,y:88.000,r:-0},2:{x:35.250,y:77.000,r:0},3:{x:66.000,y:76.500,r:-0},4:{x:26.000,y:60.500,r:0},5:{x:74.500,y:60.000,r:-0},6:{x:20.250,y:42.250,r:0},7:{x:80.250,y:42.000,r:0},8:{x:15.500,y:23.250,r:0},9:{x:85.000,y:23.500,r:-0}
    },
    morelarge: {
      1:{x:50.500,y:90.000,r:-0},2:{x:35.250,y:79.000,r:0},3:{x:66.000,y:78.500,r:-0},4:{x:26.000,y:62.500,r:0},5:{x:74.500,y:62.000,r:-0},6:{x:20.250,y:44.250,r:0},7:{x:80.250,y:44.000,r:0},8:{x:15.500,y:25.250,r:0},9:{x:85.000,y:25.500,r:-0}
    }
  },
  tight: {
    small: {
      1:{x:50.500,y:86.000,r:-0},2:{x:35.250,y:75.000,r:0},3:{x:66.000,y:74.500,r:-0},4:{x:26.000,y:58.500,r:0},5:{x:74.500,y:58.000,r:-0},6:{x:20.250,y:40.250,r:0},7:{x:80.250,y:40.000,r:0},8:{x:15.500,y:21.250,r:0},9:{x:85.000,y:21.500,r:-0}
    },
    medium: {
      1:{x:50.500,y:87.000,r:-0},2:{x:35.250,y:76.000,r:0},3:{x:66.000,y:75.500,r:-0},4:{x:26.000,y:59.500,r:0},5:{x:74.500,y:59.000,r:-0},6:{x:20.250,y:41.250,r:0},7:{x:80.250,y:41.000,r:0},8:{x:15.500,y:22.250,r:0},9:{x:85.000,y:22.500,r:-0}
    },
    large: {
      1:{x:50.500,y:88.000,r:-0},2:{x:35.250,y:77.000,r:0},3:{x:66.000,y:76.500,r:-0},4:{x:26.000,y:60.500,r:0},5:{x:74.500,y:60.000,r:-0},6:{x:20.250,y:42.250,r:0},7:{x:80.250,y:42.000,r:0},8:{x:15.500,y:23.250,r:0},9:{x:85.000,y:23.500,r:-0}
    },
    morelarge: {
      1:{x:50.500,y:90.000,r:-0},2:{x:35.250,y:79.000,r:0},3:{x:66.000,y:78.500,r:-0},4:{x:26.000,y:62.500,r:0},5:{x:74.500,y:62.000,r:-0},6:{x:20.250,y:44.250,r:0},7:{x:80.250,y:44.000,r:0},8:{x:15.500,y:25.250,r:0},9:{x:85.000,y:25.500,r:-0}
    }
  }
};

window.CP_POS_PROFILES["create-your-own-charm-necklace-14k-gold-plated-charmlab-carabiner-charm-necklace"] = {
  standard: {
    small: {
      1:{x:39.750,y:56.500,r:-0},2:{x:43.250,y:56.750,r:0},3:{x:46.750,y:57.000,r:-0},4:{x:50.250,y:57.250,r:0},5:{x:53.750,y:57.500,r:-0},6:{x:57.250,y:57.750,r:0},7:{x:60.750,y:57.750,r:0}
    },
    medium: {
      1:{x:39.750,y:57.500,r:-0},2:{x:43.250,y:57.750,r:0},3:{x:46.750,y:58.000,r:-0},4:{x:50.250,y:58.250,r:0},5:{x:53.750,y:58.500,r:-0},6:{x:57.250,y:58.750,r:0},7:{x:60.750,y:58.750,r:0}
    },
    large: {
      1:{x:39.750,y:58.500,r:-0},2:{x:43.250,y:58.750,r:0},3:{x:46.750,y:59.000,r:-0},4:{x:50.250,y:59.250,r:0},5:{x:53.750,y:59.500,r:-0},6:{x:57.250,y:59.750,r:0},7:{x:60.750,y:59.750,r:0}
    },
    morelarge: {
      1:{x:39.750,y:60.500,r:-0},2:{x:43.250,y:60.750,r:0},3:{x:46.750,y:61.000,r:-0},4:{x:50.250,y:61.250,r:0},5:{x:53.750,y:61.500,r:-0},6:{x:57.250,y:61.750,r:0},7:{x:60.750,y:61.750,r:0}
    }
  },
  tight: {
    small: {
      1:{x:39.750,y:56.500,r:-0},2:{x:43.250,y:56.750,r:0},3:{x:46.750,y:57.000,r:-0},4:{x:50.250,y:57.250,r:0},5:{x:53.750,y:57.500,r:-0},6:{x:57.250,y:57.750,r:0},7:{x:60.750,y:57.750,r:0}
    },
    medium: {
      1:{x:39.750,y:57.500,r:-0},2:{x:43.250,y:57.750,r:0},3:{x:46.750,y:58.000,r:-0},4:{x:50.250,y:58.250,r:0},5:{x:53.750,y:58.500,r:-0},6:{x:57.250,y:58.750,r:0},7:{x:60.750,y:58.750,r:0}
    },
    large: {
      1:{x:39.750,y:58.500,r:-0},2:{x:43.250,y:58.750,r:0},3:{x:46.750,y:59.000,r:-0},4:{x:50.250,y:59.250,r:0},5:{x:53.750,y:59.500,r:-0},6:{x:57.250,y:59.750,r:0},7:{x:60.750,y:59.750,r:0}
    },
    morelarge: {
      1:{x:39.750,y:60.500,r:-0},2:{x:43.250,y:60.750,r:0},3:{x:46.750,y:61.000,r:-0},4:{x:50.250,y:61.250,r:0},5:{x:53.750,y:61.500,r:-0},6:{x:57.250,y:61.750,r:0},7:{x:60.750,y:61.750,r:0}
    }
  }
};

window.CP_POS_PROFILES["create-your-own-carabiner-charm-necklace-14k-gold-plated-ot-carabiner-charm-necklace"] = {
  standard: {
    small: {
      1:{x:51.000,y:80.000,r:-0},2:{x:41.000,y:68.500,r:0},3:{x:59.000,y:68.500,r:-0},4:{x:34.500,y:59.000,r:0},5:{x:65.500,y:59.000,r:-0},6:{x:29.000,y:47.500,r:0},7:{x:71.000,y:47.500,r:0},8:{x:25.000,y:36.500,r:0},9:{x:75.000,y:36.500,r:-0}
    },
    medium: {
      1:{x:51.000,y:81.000,r:-0},2:{x:41.000,y:69.500,r:0},3:{x:59.000,y:69.500,r:-0},4:{x:34.500,y:60.000,r:0},5:{x:65.500,y:60.000,r:-0},6:{x:29.000,y:48.500,r:0},7:{x:71.000,y:48.500,r:0},8:{x:25.000,y:37.500,r:0},9:{x:75.000,y:37.500,r:-0}
    },
    large: {
      1:{x:51.000,y:82.000,r:-0},2:{x:41.000,y:70.500,r:0},3:{x:59.000,y:70.500,r:-0},4:{x:34.500,y:61.000,r:0},5:{x:65.500,y:61.000,r:-0},6:{x:29.000,y:49.500,r:0},7:{x:71.000,y:49.500,r:0},8:{x:25.000,y:38.500,r:0},9:{x:75.000,y:38.500,r:-0}
    },
    morelarge: {
      1:{x:51.000,y:84.000,r:-0},2:{x:41.000,y:72.500,r:0},3:{x:59.000,y:72.500,r:-0},4:{x:34.500,y:63.000,r:0},5:{x:65.500,y:63.000,r:-0},6:{x:29.000,y:51.500,r:0},7:{x:71.000,y:51.500,r:0},8:{x:25.000,y:40.500,r:0},9:{x:75.000,y:40.500,r:-0}
    }
  },
  tight: {
    small: {
      1:{x:51.000,y:80.000,r:-0},2:{x:41.000,y:68.500,r:0},3:{x:59.000,y:68.500,r:-0},4:{x:34.500,y:59.000,r:0},5:{x:65.500,y:59.000,r:-0},6:{x:29.000,y:47.500,r:0},7:{x:71.000,y:47.500,r:0},8:{x:25.000,y:36.500,r:0},9:{x:75.000,y:36.500,r:-0}
    },
    medium: {
      1:{x:51.000,y:81.000,r:-0},2:{x:41.000,y:69.500,r:0},3:{x:59.000,y:69.500,r:-0},4:{x:34.500,y:60.000,r:0},5:{x:65.500,y:60.000,r:-0},6:{x:29.000,y:48.500,r:0},7:{x:71.000,y:48.500,r:0},8:{x:25.000,y:37.500,r:0},9:{x:75.000,y:37.500,r:-0}
    },
    large: {
      1:{x:51.000,y:82.000,r:-0},2:{x:41.000,y:70.500,r:0},3:{x:59.000,y:70.500,r:-0},4:{x:34.500,y:61.000,r:0},5:{x:65.500,y:61.000,r:-0},6:{x:29.000,y:49.500,r:0},7:{x:71.000,y:49.500,r:0},8:{x:25.000,y:38.500,r:0},9:{x:75.000,y:38.500,r:-0}
    },
    morelarge: {
      1:{x:51.000,y:84.000,r:-0},2:{x:41.000,y:72.500,r:0},3:{x:59.000,y:72.500,r:-0},4:{x:34.500,y:63.000,r:0},5:{x:65.500,y:63.000,r:-0},6:{x:29.000,y:51.500,r:0},7:{x:71.000,y:51.500,r:0},8:{x:25.000,y:40.500,r:0},9:{x:75.000,y:40.500,r:-0}
    }
  }
};

window.CP_POS_PROFILES["create-your-own-carabiner-charm-necklace-14k-gold-plated-round-carabiner-charm-necklace"] = {
  standard: {
    small: {
      1:{x:50.000,y:78.000,r:-0},2:{x:42.000,y:70.000,r:0},3:{x:58.500,y:70.000,r:-0},4:{x:34.500,y:59.000,r:0},5:{x:65.500,y:59.000,r:-0},6:{x:29.000,y:47.500,r:0},7:{x:71.000,y:47.500,r:0},8:{x:24.750,y:35.000,r:0},9:{x:75.250,y:35.000,r:-0}
    },
    medium: {
      1:{x:50.000,y:79.000,r:-0},2:{x:42.000,y:71.000,r:0},3:{x:58.500,y:71.000,r:-0},4:{x:34.500,y:60.000,r:0},5:{x:65.500,y:60.000,r:-0},6:{x:29.000,y:48.500,r:0},7:{x:71.000,y:48.500,r:0},8:{x:24.750,y:36.000,r:0},9:{x:75.250,y:36.000,r:-0}
    },
    large: {
      1:{x:50.000,y:80.000,r:-0},2:{x:42.000,y:72.000,r:0},3:{x:58.500,y:72.000,r:-0},4:{x:34.500,y:61.000,r:0},5:{x:65.500,y:61.000,r:-0},6:{x:29.000,y:49.500,r:0},7:{x:71.000,y:49.500,r:0},8:{x:24.750,y:37.000,r:0},9:{x:75.250,y:37.000,r:-0}
    },
    morelarge: {
      1:{x:50.000,y:82.000,r:-0},2:{x:42.000,y:74.000,r:0},3:{x:58.500,y:74.000,r:-0},4:{x:34.500,y:63.000,r:0},5:{x:65.500,y:63.000,r:-0},6:{x:29.000,y:51.500,r:0},7:{x:71.000,y:51.500,r:0},8:{x:24.750,y:39.000,r:0},9:{x:75.250,y:39.000,r:-0}
    }
  },
  tight: {
    small: {
      1:{x:50.000,y:78.000,r:-0},2:{x:42.000,y:70.000,r:0},3:{x:58.500,y:70.000,r:-0},4:{x:34.500,y:59.000,r:0},5:{x:65.500,y:59.000,r:-0},6:{x:29.000,y:47.500,r:0},7:{x:71.000,y:47.500,r:0},8:{x:24.750,y:35.000,r:0},9:{x:75.250,y:35.000,r:-0}
    },
    medium: {
      1:{x:50.000,y:79.000,r:-0},2:{x:42.000,y:71.000,r:0},3:{x:58.500,y:71.000,r:-0},4:{x:34.500,y:60.000,r:0},5:{x:65.500,y:60.000,r:-0},6:{x:29.000,y:48.500,r:0},7:{x:71.000,y:48.500,r:0},8:{x:24.750,y:36.000,r:0},9:{x:75.250,y:36.000,r:-0}
    },
    large: {
      1:{x:50.000,y:80.000,r:-0},2:{x:42.000,y:72.000,r:0},3:{x:58.500,y:72.000,r:-0},4:{x:34.500,y:61.000,r:0},5:{x:65.500,y:61.000,r:-0},6:{x:29.000,y:49.500,r:0},7:{x:71.000,y:49.500,r:0},8:{x:24.750,y:37.000,r:0},9:{x:75.250,y:37.000,r:-0}
    },
    morelarge: {
      1:{x:50.000,y:82.000,r:-0},2:{x:42.000,y:74.000,r:0},3:{x:58.500,y:74.000,r:-0},4:{x:34.500,y:63.000,r:0},5:{x:65.500,y:63.000,r:-0},6:{x:29.000,y:51.500,r:0},7:{x:71.000,y:51.500,r:0},8:{x:24.750,y:39.000,r:0},9:{x:75.250,y:39.000,r:-0}
    }
  }
};

window.CP_POS_PROFILES["create-your-own-beaded-charm-necklace-coral-gemstone-freshwater-pearl-beaded-charm-necklace"] = {
  standard: {
    small: {
      1:{x:49.990,y:83.097,r:-0},2:{x:35.715,y:74.485,r:0},3:{x:64.085,y:74.085,r:-0},4:{x:28.055,y:61.473,r:0},5:{x:72.055,y:61.473,r:-0},6:{x:24.452,y:48.031,r:0},7:{x:76.789,y:48.031,r:0},8:{x:20.589,y:29.214,r:0},9:{x:79.511,y:29.214,r:-0}
    },
    medium: {
      1:{x:49.990,y:84.097,r:-0},2:{x:35.715,y:75.485,r:0},3:{x:64.085,y:75.085,r:-0},4:{x:28.055,y:62.473,r:0},5:{x:72.055,y:62.473,r:-0},6:{x:24.452,y:49.031,r:0},7:{x:76.789,y:49.031,r:0},8:{x:20.589,y:30.214,r:0},9:{x:79.511,y:30.214,r:-0}
    },
    large: {
      1:{x:49.990,y:85.097,r:-0},2:{x:35.715,y:76.485,r:0},3:{x:64.085,y:76.085,r:-0},4:{x:28.055,y:63.073,r:0},5:{x:72.055,y:63.073,r:-0},6:{x:24.452,y:49.031,r:0},7:{x:76.789,y:49.031,r:0},8:{x:20.589,y:31.214,r:0},9:{x:79.511,y:31.214,r:-0}
    },
    morelarge: {
      1:{x:49.990,y:87.097,r:-0},2:{x:35.715,y:78.485,r:0},3:{x:64.085,y:78.085,r:-0},4:{x:28.055,y:65.073,r:0},5:{x:72.055,y:65.073,r:-0},6:{x:24.452,y:51.031,r:0},7:{x:76.789,y:51.031,r:0},8:{x:20.589,y:33.214,r:0},9:{x:79.511,y:33.214,r:-0}
    }
  },
  tight: {
    small: {
      1:{x:49.990,y:83.097,r:-0},2:{x:35.715,y:74.485,r:0},3:{x:64.085,y:74.085,r:-0},4:{x:28.055,y:61.473,r:0},5:{x:72.055,y:61.473,r:-0},6:{x:24.452,y:48.031,r:0},7:{x:76.789,y:48.031,r:0},8:{x:20.589,y:29.214,r:0},9:{x:79.511,y:29.214,r:-0}
    },
    medium: {
      1:{x:49.990,y:84.097,r:-0},2:{x:35.715,y:75.485,r:0},3:{x:64.085,y:75.085,r:-0},4:{x:28.055,y:62.473,r:0},5:{x:72.055,y:62.473,r:-0},6:{x:24.452,y:49.031,r:0},7:{x:76.789,y:49.031,r:0},8:{x:20.589,y:30.214,r:0},9:{x:79.511,y:30.214,r:-0}
    },
    large: {
      1:{x:49.990,y:85.097,r:-0},2:{x:35.715,y:76.485,r:0},3:{x:64.085,y:76.085,r:-0},4:{x:28.055,y:63.073,r:0},5:{x:72.055,y:63.073,r:-0},6:{x:24.452,y:49.031,r:0},7:{x:76.789,y:49.031,r:0},8:{x:20.589,y:31.214,r:0},9:{x:79.511,y:31.214,r:-0}
    },
    morelarge: {
      1:{x:49.990,y:87.097,r:-0},2:{x:35.715,y:78.485,r:0},3:{x:64.085,y:78.085,r:-0},4:{x:28.055,y:65.073,r:0},5:{x:72.055,y:65.073,r:-0},6:{x:24.452,y:51.031,r:0},7:{x:76.789,y:51.031,r:0},8:{x:20.589,y:33.214,r:0},9:{x:79.511,y:33.214,r:-0}
    }
  }
};

window.CP_POS_PROFILES["create-your-own-charm-pin-brooch-by-prasinous"] = {
  standard: {
    small: {
      1:{x:39.750,y:56.500,r:-0},2:{x:43.250,y:56.750,r:0},3:{x:46.750,y:57.000,r:-0},4:{x:50.250,y:57.250,r:0},5:{x:53.750,y:57.500,r:-0},6:{x:57.250,y:57.750,r:0},7:{x:60.750,y:57.750,r:0}
    },
    medium: {
      1:{x:39.750,y:57.500,r:-0},2:{x:43.250,y:57.750,r:0},3:{x:46.750,y:58.000,r:-0},4:{x:50.250,y:58.250,r:0},5:{x:53.750,y:58.500,r:-0},6:{x:57.250,y:58.750,r:0},7:{x:60.750,y:58.750,r:0}
    },
    large: {
      1:{x:39.750,y:58.500,r:-0},2:{x:43.250,y:58.750,r:0},3:{x:46.750,y:59.000,r:-0},4:{x:50.250,y:59.250,r:0},5:{x:53.750,y:59.500,r:-0},6:{x:57.250,y:59.750,r:0},7:{x:60.750,y:59.750,r:0}
    },
    morelarge: {
      1:{x:39.750,y:60.500,r:-0},2:{x:43.250,y:60.750,r:0},3:{x:46.750,y:61.000,r:-0},4:{x:50.250,y:61.250,r:0},5:{x:53.750,y:61.500,r:-0},6:{x:57.250,y:61.750,r:0},7:{x:60.750,y:61.750,r:0}
    }
  },
  tight: {
    small: {
      1:{x:39.750,y:56.500,r:-0},2:{x:43.250,y:56.750,r:0},3:{x:46.750,y:57.000,r:-0},4:{x:50.250,y:57.250,r:0},5:{x:53.750,y:57.500,r:-0},6:{x:57.250,y:57.750,r:0},7:{x:60.750,y:57.750,r:0}
    },
    medium: {
      1:{x:39.750,y:57.500,r:-0},2:{x:43.250,y:57.750,r:0},3:{x:46.750,y:58.000,r:-0},4:{x:50.250,y:58.250,r:0},5:{x:53.750,y:58.500,r:-0},6:{x:57.250,y:58.750,r:0},7:{x:60.750,y:58.750,r:0}
    },
    large: {
      1:{x:39.750,y:58.500,r:-0},2:{x:43.250,y:58.750,r:0},3:{x:46.750,y:59.000,r:-0},4:{x:50.250,y:59.250,r:0},5:{x:53.750,y:59.500,r:-0},6:{x:57.250,y:59.750,r:0},7:{x:60.750,y:59.750,r:0}
    },
    morelarge: {
      1:{x:39.750,y:60.500,r:-0},2:{x:43.250,y:60.750,r:0},3:{x:46.750,y:61.000,r:-0},4:{x:50.250,y:61.250,r:0},5:{x:53.750,y:61.500,r:-0},6:{x:57.250,y:61.750,r:0},7:{x:60.750,y:61.750,r:0}
    }
  }
};

window.CP_POS_PROFILES["personalize-your-gemstone-bag-charm-coral-pearl-beaded"] = {
  standard: {
    small: {
      1:{x:50.220,y:84.597,r:-0},2:{x:47.250,y:83.585,r:35},3:{x:53.000,y:83.585,r:-35},4:{x:23.555,y:62.273,r:55},5:{x:77.355,y:61.473,r:-57.5},6:{x:21.502,y:44.831,r:102.5},7:{x:78.689,y:44.231,r:-102.5},8:{x:29.389,y:30.114,r:140},9:{x:70.011,y:29.514,r:-140}
    },
    medium: {
      1:{x:50.220,y:85.347,r:-0},2:{x:46.750,y:84.685,r:35},3:{x:53.000,y:84.085,r:-35},4:{x:22.855,y:62.773,r:55},5:{x:78.355,y:61.473,r:-57.5},6:{x:20.502,y:44.831,r:102.5},7:{x:79.689,y:44.231,r:-102.5},8:{x:29.089,y:29.314,r:140},9:{x:70.011,y:29.014,r:-140}
    },
    large: {
      1:{x:50.220,y:86.297,r:-0},2:{x:46.250,y:84.885,r:35},3:{x:54.600,y:84.785,r:-35},4:{x:22.355,y:63.473,r:55},5:{x:78.755,y:62.273,r:-57.5},6:{x:19.702,y:44.531,r:102.5},7:{x:80.489,y:44.031,r:-102.5},8:{x:27.989,y:28.814,r:140},9:{x:70.971,y:28.114,r:-140}
    },
    morelarge: {
      1:{x:50.220,y:86.497,r:-0},2:{x:46.000,y:84.785,r:35},3:{x:53.000,y:84.785,r:-35},4:{x:21.855,y:64.073,r:55},5:{x:79.155,y:62.973,r:-57.5},6:{x:18.852,y:44.331,r:102.5},7:{x:81.289,y:43.831,r:-102.5},8:{x:27.075,y:28.114,r:140},9:{x:71.871,y:27.214,r:-140}
    }
  },
  tight: {
    small: {
      1:{x:50.620,y:79.097,r:-0},2:{x:34.915,y:74.985,r:25},3:{x:66.585,y:74.385,r:-25},4:{x:23.555,y:62.273,r:55},5:{x:77.355,y:61.473,r:-57.5},6:{x:21.502,y:44.831,r:102.5},7:{x:78.689,y:44.231,r:-102.5},8:{x:29.389,y:30.114,r:140},9:{x:70.011,y:29.514,r:-140}
    },
    medium: {
      1:{x:50.620,y:79.597,r:-0},2:{x:34.415,y:75.485,r:25},3:{x:67.085,y:75.285,r:-25},4:{x:22.855,y:62.773,r:55},5:{x:78.355,y:61.473,r:-57.5},6:{x:20.502,y:44.831,r:102.5},7:{x:79.689,y:44.231,r:-102.5},8:{x:29.089,y:29.314,r:140},9:{x:70.011,y:29.014,r:-140}
    },
    large: {
      1:{x:50.620,y:80.797,r:-0},2:{x:34.115,y:76.285,r:25},3:{x:67.085,y:75.685,r:-25},4:{x:22.355,y:63.473,r:55},5:{x:78.755,y:62.273,r:-57.5},6:{x:19.702,y:44.531,r:102.5},7:{x:80.489,y:44.031,r:-102.5},8:{x:27.989,y:28.814,r:140},9:{x:70.971,y:28.114,r:-140}
    },
    morelarge: {
      1:{x:50.620,y:82.097,r:-0},2:{x:33.815,y:77.085,r:25},3:{x:67.385,y:76.885,r:-25},4:{x:21.855,y:64.073,r:55},5:{x:79.155,y:62.973,r:-57.5},6:{x:18.852,y:44.331,r:102.5},7:{x:81.289,y:43.831,r:-102.5},8:{x:27.075,y:28.114,r:140},9:{x:71.871,y:27.214,r:-140}
    }
  }
};

window.CP_POS_PROFILES["personalize-your-gemstone-bag-charm-moonstone-aquamarine-beaded"] = {
  standard: {
    small: {
      1:{x:50.220,y:84.597,r:-0},2:{x:47.250,y:83.585,r:35},3:{x:53.000,y:83.585,r:-35},4:{x:23.555,y:62.273,r:55},5:{x:77.355,y:61.473,r:-57.5},6:{x:21.502,y:44.831,r:102.5},7:{x:78.689,y:44.231,r:-102.5},8:{x:29.389,y:30.114,r:140},9:{x:70.011,y:29.514,r:-140}
    },
    medium: {
      1:{x:50.220,y:85.347,r:-0},2:{x:46.750,y:84.685,r:35},3:{x:53.000,y:84.085,r:-35},4:{x:22.855,y:62.773,r:55},5:{x:78.355,y:61.473,r:-57.5},6:{x:20.502,y:44.831,r:102.5},7:{x:79.689,y:44.231,r:-102.5},8:{x:29.089,y:29.314,r:140},9:{x:70.011,y:29.014,r:-140}
    },
    large: {
      1:{x:50.220,y:86.297,r:-0},2:{x:46.250,y:84.885,r:35},3:{x:54.600,y:84.785,r:-35},4:{x:22.355,y:63.473,r:55},5:{x:78.755,y:62.273,r:-57.5},6:{x:19.702,y:44.531,r:102.5},7:{x:80.489,y:44.031,r:-102.5},8:{x:27.989,y:28.814,r:140},9:{x:70.971,y:28.114,r:-140}
    },
    morelarge: {
      1:{x:50.220,y:86.497,r:-0},2:{x:46.000,y:84.785,r:35},3:{x:53.000,y:84.785,r:-35},4:{x:21.855,y:64.073,r:55},5:{x:79.155,y:62.973,r:-57.5},6:{x:18.852,y:44.331,r:102.5},7:{x:81.289,y:43.831,r:-102.5},8:{x:27.075,y:28.114,r:140},9:{x:71.871,y:27.214,r:-140}
    }
  },
  tight: {
    small: {
      1:{x:50.620,y:79.097,r:-0},2:{x:34.915,y:74.985,r:25},3:{x:66.585,y:74.385,r:-25},4:{x:23.555,y:62.273,r:55},5:{x:77.355,y:61.473,r:-57.5},6:{x:21.502,y:44.831,r:102.5},7:{x:78.689,y:44.231,r:-102.5},8:{x:29.389,y:30.114,r:140},9:{x:70.011,y:29.514,r:-140}
    },
    medium: {
      1:{x:50.620,y:79.597,r:-0},2:{x:34.415,y:75.485,r:25},3:{x:67.085,y:75.285,r:-25},4:{x:22.855,y:62.773,r:55},5:{x:78.355,y:61.473,r:-57.5},6:{x:20.502,y:44.831,r:102.5},7:{x:79.689,y:44.231,r:-102.5},8:{x:29.089,y:29.314,r:140},9:{x:70.011,y:29.014,r:-140}
    },
    large: {
      1:{x:50.620,y:80.797,r:-0},2:{x:34.115,y:76.285,r:25},3:{x:67.085,y:75.685,r:-25},4:{x:22.355,y:63.473,r:55},5:{x:78.755,y:62.273,r:-57.5},6:{x:19.702,y:44.531,r:102.5},7:{x:80.489,y:44.031,r:-102.5},8:{x:27.989,y:28.814,r:140},9:{x:70.971,y:28.114,r:-140}
    },
    morelarge: {
      1:{x:50.620,y:82.097,r:-0},2:{x:33.815,y:77.085,r:25},3:{x:67.385,y:76.885,r:-25},4:{x:21.855,y:64.073,r:55},5:{x:79.155,y:62.973,r:-57.5},6:{x:18.852,y:44.331,r:102.5},7:{x:81.289,y:43.831,r:-102.5},8:{x:27.075,y:28.114,r:140},9:{x:71.871,y:27.214,r:-140}
    }
  }
};

window.CP_POS_PROFILES["personalize-your-gemstone-bag-charm-tigers-eye-quartz-carnelian"] = {
  standard: {
    small: {
      1:{x:50.220,y:84.597,r:-0},2:{x:47.250,y:83.585,r:35},3:{x:53.000,y:83.585,r:-35},4:{x:23.555,y:62.273,r:55},5:{x:77.355,y:61.473,r:-57.5},6:{x:21.502,y:44.831,r:102.5},7:{x:78.689,y:44.231,r:-102.5},8:{x:29.389,y:30.114,r:140},9:{x:70.011,y:29.514,r:-140}
    },
    medium: {
      1:{x:50.220,y:85.347,r:-0},2:{x:46.750,y:84.685,r:35},3:{x:53.000,y:84.085,r:-35},4:{x:22.855,y:62.773,r:55},5:{x:78.355,y:61.473,r:-57.5},6:{x:20.502,y:44.831,r:102.5},7:{x:79.689,y:44.231,r:-102.5},8:{x:29.089,y:29.314,r:140},9:{x:70.011,y:29.014,r:-140}
    },
    large: {
      1:{x:50.220,y:86.297,r:-0},2:{x:46.250,y:84.885,r:35},3:{x:54.600,y:84.785,r:-35},4:{x:22.355,y:63.473,r:55},5:{x:78.755,y:62.273,r:-57.5},6:{x:19.702,y:44.531,r:102.5},7:{x:80.489,y:44.031,r:-102.5},8:{x:27.989,y:28.814,r:140},9:{x:70.971,y:28.114,r:-140}
    },
    morelarge: {
      1:{x:50.220,y:86.497,r:-0},2:{x:46.000,y:84.785,r:35},3:{x:53.000,y:84.785,r:-35},4:{x:21.855,y:64.073,r:55},5:{x:79.155,y:62.973,r:-57.5},6:{x:18.852,y:44.331,r:102.5},7:{x:81.289,y:43.831,r:-102.5},8:{x:27.075,y:28.114,r:140},9:{x:71.871,y:27.214,r:-140}
    }
  },
  tight: {
    small: {
      1:{x:50.620,y:79.097,r:-0},2:{x:34.915,y:74.985,r:25},3:{x:66.585,y:74.385,r:-25},4:{x:23.555,y:62.273,r:55},5:{x:77.355,y:61.473,r:-57.5},6:{x:21.502,y:44.831,r:102.5},7:{x:78.689,y:44.231,r:-102.5},8:{x:29.389,y:30.114,r:140},9:{x:70.011,y:29.514,r:-140}
    },
    medium: {
      1:{x:50.620,y:79.597,r:-0},2:{x:34.415,y:75.485,r:25},3:{x:67.085,y:75.285,r:-25},4:{x:22.855,y:62.773,r:55},5:{x:78.355,y:61.473,r:-57.5},6:{x:20.502,y:44.831,r:102.5},7:{x:79.689,y:44.231,r:-102.5},8:{x:29.089,y:29.314,r:140},9:{x:70.011,y:29.014,r:-140}
    },
    large: {
      1:{x:50.620,y:80.797,r:-0},2:{x:34.115,y:76.285,r:25},3:{x:67.085,y:75.685,r:-25},4:{x:22.355,y:63.473,r:55},5:{x:78.755,y:62.273,r:-57.5},6:{x:19.702,y:44.531,r:102.5},7:{x:80.489,y:44.031,r:-102.5},8:{x:27.989,y:28.814,r:140},9:{x:70.971,y:28.114,r:-140}
    },
    morelarge: {
      1:{x:50.620,y:82.097,r:-0},2:{x:33.815,y:77.085,r:25},3:{x:67.385,y:76.885,r:-25},4:{x:21.855,y:64.073,r:55},5:{x:79.155,y:62.973,r:-57.5},6:{x:18.852,y:44.331,r:102.5},7:{x:81.289,y:43.831,r:-102.5},8:{x:27.075,y:28.114,r:140},9:{x:71.871,y:27.214,r:-140}
    }
  }
};